import React from 'react';
import { Attention } from '@yme/assets/icons';
import { SVGIcon } from '@yme/atoms/svg-icon';
import { NEWS_TYPE } from '@yme/organisms/news-events-grid/constants';
import { colorCoreWhite1000 } from '@yme/tokens/colors';
import { RegularTextLevel3, RegularTextLevel4 } from '@yme/tokens/typography';
import { NoResultIconStyled, NoResultIconWrapperStyled, NoResultsPageStyled } from './styled';
export function NoResultsPage({ labels, isLoaded, gridType }) {
    const { newsGrid_noNewsFound_label: noNewsLabel, eventsGrid_noEventsFound_label: noEventsLabel } = labels;
    const noResultLabel = gridType === NEWS_TYPE ? noNewsLabel : noEventsLabel;
    if (!isLoaded) {
        return null;
    }
    return (React.createElement(NoResultsPageStyled, { padding: "96px 0", alignItems: "center", justifyContent: "center", flexDirection: "column", gap: "4px" },
        React.createElement(NoResultIconWrapperStyled, { alignItems: "center", justifyContent: "center" },
            React.createElement(NoResultIconStyled, { alignItems: "center", justifyContent: "center" },
                React.createElement(SVGIcon, { type: Attention, pathFill: colorCoreWhite1000 }))),
        React.createElement(RegularTextLevel3, { weight: 500 }, noResultLabel),
        React.createElement(RegularTextLevel4, null, labels.newsEventsGrid_changeFilters_hint)));
}
